// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconStyledForChips-module_icon__W3smo_ETwMzwFTxCuhhM","avatar":"IconStyledForChips-module_avatar__clNrj9Wu7nIAEanLzJSU"};